import { useHasOnlyDismissedHighPriorityNotifications } from "@faire/deprecated-retailer-visitor-shared/components/Header/HeaderNotifications/__internal__/NotificationDropdown/hooks/useHasOnlyDismissedHighPriorityNotifications";
import { useNotifications } from "@faire/deprecated-retailer-visitor-shared/components/Header/HeaderNotifications/hooks/useNotifications";
import { home } from "@faire/deprecated-retailer-visitor-shared/paths/index";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { matchPath } from "react-router-dom";

export const useShouldPerformHighPriorityAction = () => {
  const hasOnlyDismissedHighPriorityNotifications =
    useHasOnlyDismissedHighPriorityNotifications();
  const { pathname } = useLocation();
  const isOnHome = matchPath(pathname, {
    path: home(),
    exact: true,
  });
  const { notifications } = useNotifications();
  const notification = useMemo(
    () =>
      notifications?.find((notification) => notification.priority === "HIGH"),
    [notifications]
  );
  const notificationPath = notification?.message?.path ?? "";
  return (
    (!pathname.includes(notificationPath) || !!isOnHome) &&
    hasOnlyDismissedHighPriorityNotifications
  );
};
